import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3'
    },
    content: {
        flexBasis: 'auto' as const,
        padding: '2.5rem 0',
        marginTop: '-1rem'
    },
    mainLabel: {
        fontSize: '1.2rem',
        borderBottom: '1px solid #cccccc'
    },
    mainContent: {
        padding: '1.7rem 1.5rem 1rem 0',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    sectionContainer: {
        minHeight: '350px',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        marginTop: '1rem'
    },
    statisticsSectionContainer: {
        width: 'auto' as const,
        height: 'auto' as const,
        minHeight: '300px',
        maxHeight: '40vh',
        overflowY: 'auto' as const,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '2rem 4rem',
        marginTop: '1rem',
        '@media (min-height: 920px)': { maxHeight: '50vh' }
    },
    detailContainer: {
        paddingTop: '2.25rem',
        '&:first-child': { paddingTop: '0' }
    },
    detailLabel: { paddingBottom: '.3rem' },
    detailText: { fontSize: '1.2rem' },
    firmActionButtonsContainer: { width: 'auto' as const },
    actionButton: {
        marginLeft: '.5rem',
        '&:first-child': { marginLeft: '0' }
    },
    createdText: {
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        fontSize: '.8rem'
    },
    noNotes: {
        color: theme?.app?.applicationColors.enumColors.greyLighter ||
            '#cfcfcf'
    },
    boldText: { fontWeight: 'bold' as const },
    statContainer: { paddingBottom: '16px' }
});